import Vue from 'vue';

import PButton from './PButton.vue';
import PErrorDisplay from './PErrorDisplay.vue';
import PForm from './PForm.vue';
import PFileSelector from './PFileSelector.vue';
import PFormGroupRow from './PFormGroupRow.vue';
import PInput from './PInput.vue';
import PPage from './PPage.vue';
import PSelect from './PSelect.vue';
import PSlider from './PSlider.vue';
import PWYSIWYG from './PWYSIWYG.vue';

Vue.component('PButton', PButton);
Vue.component('PErrorDisplay', PErrorDisplay);
Vue.component('PForm', PForm);
Vue.component('PFileSelector', PFileSelector);
Vue.component('PFormGroupRow', PFormGroupRow);
Vue.component('PInput', PInput);
Vue.component('PPage', PPage);
Vue.component('PSelect', PSelect);
Vue.component('PSlider', PSlider);
Vue.component('PWYSIWYG', PWYSIWYG);
